import Wolf from './Wolf.vue';

export default Wolf;
